"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceJpgWithWebp = void 0;
const replaceJpgWithWebp = () => {
    const isWebpAvailable = document.querySelector('html');
    if (isWebpAvailable?.classList.contains('webp')) {
        document.querySelectorAll('[data-fancybox="media"]').forEach(elem => {
            if (elem instanceof HTMLElement) {
                let multilineSrc = elem.dataset.srcset?.replace(/jpg/g, 'webp').trim();
                let singleSrc = elem.dataset.src?.replace('jpg', 'webp');
                elem.dataset.srcset = multilineSrc;
                elem.dataset.src = singleSrc;
            }
        });
    }
};
exports.replaceJpgWithWebp = replaceJpgWithWebp;
